"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Definition = void 0;
const lodash_functions_1 = require("../../../util/lodash-functions");
const default_session_1 = require("../../../session/default-session");
const ioc_1 = require("./ioc");
function Definition(type, params) {
    const parameters = (0, lodash_functions_1.isPlainObject)(params)
        ? params
        : { universe: params };
    return {
        getStream(session = (0, default_session_1.getDefault)()) {
            return new ioc_1.TsiIocContainerImpl()
                .setTimeSeriesParams(parameters)
                .setTimeSeriesType(type)
                .setTimeSeriesSession(session)
                .getContainer()
                .get('TimeSeriesFacadeStream');
        },
    };
}
exports.Definition = Definition;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZGVmaW5pdGlvbi5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uLy4uL3NyYy9jb250ZW50L2hpc3RvcmljYWwtcHJpY2luZy90aW1lLXNlcmllcy9kZWZpbml0aW9uLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUFBLHFFQUErRDtBQUUvRCxzRUFBOEQ7QUFDOUQsK0JBQTRDO0FBVTVDLFNBQWdCLFVBQVUsQ0FDdEIsSUFBaUQsRUFDakQsTUFBb0Q7SUFFcEQsTUFBTSxVQUFVLEdBQXdDLElBQUEsZ0NBQWEsRUFBQyxNQUFNLENBQUM7UUFDekUsQ0FBQyxDQUFFLE1BQThDO1FBQ2pELENBQUMsQ0FBQyxFQUFFLFFBQVEsRUFBRSxNQUFnQixFQUFFLENBQUM7SUFDckMsT0FBTztRQUNILFNBQVMsQ0FDTCxVQUFtQixJQUFBLDRCQUFVLEdBQUU7WUFFL0IsT0FBTyxJQUFJLHlCQUFtQixFQUFFO2lCQUMzQixtQkFBbUIsQ0FBQyxVQUFVLENBQUM7aUJBQy9CLGlCQUFpQixDQUFDLElBQUksQ0FBQztpQkFDdkIsb0JBQW9CLENBQUMsT0FBTyxDQUFDO2lCQUM3QixZQUFZLEVBQUU7aUJBQ2QsR0FBRyxDQUE2Rix3QkFBd0IsQ0FBQyxDQUFDO1FBQ25JLENBQUM7S0FDSixDQUFDO0FBQ04sQ0FBQztBQW5CRCxnQ0FtQkMifQ==